<template>
  <div>
    <b-row
      v-if="existingSubscriptions && existingSubscriptions.length > 0"
      align-h="center"
      class="mb-0 pb-0 current-plan"
      no-gutters
    >
      <b-col>
        <div align-h="around" class="row mb-3 ml-3 mr-3">
          <p class="text-center plan-details-header" data-test-hook="current-plan-support-text">
            {{ $t('xCurrentPlanSupport', { 0: existingSubscriptions[0].product.name }) }}
          </p>
        </div>
      </b-col>
    </b-row>
    <SubscriptionCard
      :subscription-product="existingSubscriptions[0].product"
      :existing-apparatuses="subscriptionApparatusData"
      :apparatuses-to-add="[apparatusDetails]"
      :is-new-plan="false"
      :are-all-covered="true"
    />
    <b-row no-gutters class="mt-3">
      <b-col cols="12" class="float-left pl-2">
        <b-button
          variant="warning"
          class="w-100"
          :disabled="subscribing"
          @click="addApparatusToSubscription"
          data-test-hook="existing-subscription-modal-confirm-plan-button"
        >
          {{ $t('xContinue') }}
          <b-spinner class="ml-2" v-if="subscribing"></b-spinner>
        </b-button>
      </b-col>
    </b-row>
    <div v-if="showSelectSubError" class="alert alert--validation alert-danger" :show="showSelectSubError">
      {{ $t('xFailedSetUpGeneratorSubscription') }}
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'
import SubscriptionCard from './Common/SubscriptionCard.vue'

export default {
  props: ['existingSubscriptions', 'apparatusDetails', 'apparatusId', 'accountProfile', 'apparatusList', 'modalId'],
  components: {
    SubscriptionCard
  },
  data() {
    return {
      subscribing: false,
      showSelectSubError: false,
      subscriptionApparatusData: []
    }
  },
  mounted() {
    this.loadSubscriptionApparatusData()
  },
  methods: {
    loadSubscriptionApparatusData() {
      const apparatusIdList = this.existingSubscriptions?.[0]?.apparatuses ?? []
      if (!apparatusIdList?.length || !this.apparatusList?.length) {
        return []
      }
      this.subscriptionApparatusData = apparatusIdList.map(appId => {
        return this.apparatusList.find(app => app.apparatusId === appId?.apparatusId)
      })
    },
    addApparatusToSubscription() {
      this.subscribing = true
      let appId = null
      if (this.apparatusId) {
        appId = this.apparatusId
      } else {
        this.showSelectSubError = true
        return
      }
      let apparatusIdList = []
      this.existingSubscriptions[0].apparatuses.forEach(apparatus => {
        apparatusIdList.push(apparatus.apparatusId)
      })
      apparatusIdList.push(appId)
      let store = ''
      switch (this.existingSubscriptions[0].store) {
        case 0:
          store = 'Apple'
          break
        case 1:
          store = 'Google'
          break
        case 2:
          store = 'Web'
          break
        case 3:
          store = 'Dealer'
          break
        default:
          break
      }
      this.$store
        .dispatch('updateSubscriptionApparatuses', {
          organizationId: this.accountProfile.organizationId,
          store: store,
          productId: this.existingSubscriptions[0].product.productId,
          apparatusIds: apparatusIdList
        })
        .then(response => {
          this.$bvModal.hide(this.modalId)
          const appType = this.apparatusDetails?.type || this.apparatusDetails?.apparatusType
          if (appType === Constants.HsbApparatusType) {
            this.openModal('subscription-success')
          } else if (appType === Constants.FuelTankApparatusType) {
            this.$bvModal.show('tank-enrollment-success')
          }
        })
        .catch(error => {
          this.showSelectSubError = true
        })
        .finally(() => {
          this.subscribing = false
        })
    }
  }
}
</script>
<style lang="scss">
.current-plan {
  .plan-details-header {
    font-size: 1.125em;
    line-height: 1.25;
    font-weight: 500;
  }
}
</style>
